// extracted by mini-css-extract-plugin
export var addButton = "_ev-0";
export var border = "_ev-8";
export var check = "_ev-h";
export var danger = "_ev-6";
export var dropdownContainer = "_ev-1";
export var editModalBody = "_ev-j";
export var footerContainer = "_ev-i";
export var fullWidth = "_ev-a";
export var hide = "_ev-9";
export var icon = "_ev-3";
export var input = "_ev-7";
export var inputFlex = "_ev-b";
export var inputWrapper = "_ev-c";
export var manualFocus = "_ev-5";
export var optionButton = "_ev-4";
export var pillWrapper = "_ev-e";
export var pointer = "_ev-2";
export var showOverflow = "_ev-f";
export var tagsFlex = "_ev-d";
export var xButton = "_ev-g";